var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3,0H1.7C1.4,0,1.1,0.2,0.9,0.4c-0.2,0.3-0.4,0.6-0.4,1v13.1c0,0.4,0.1,0.8,0.4,1C1.1,15.8,1.4,16,1.7,16 h13.5c0.3,0,0.6-0.2,0.9-0.4c0.2-0.3,0.4-0.6,0.4-1V1.5c0-0.4-0.1-0.8-0.4-1C15.9,0.2,15.6,0,15.3,0z M15.3,1.5v9.3l-2-2.4 c-0.1-0.1-0.2-0.2-0.4-0.3C12.7,8,12.6,8,12.4,8c-0.2,0-0.3,0-0.5,0.1c-0.1,0.1-0.3,0.2-0.4,0.3L10,10.2l-3.4-4 C6.4,6,6.1,5.8,5.7,5.8S5.1,6,4.9,6.2L1.7,9.9V1.5H15.3z M1.7,12l4-4.7l6.2,7.3H1.7V12z M15.3,14.5h-1.6l-2.8-3.3l1.5-1.8l2.9,3.4 V14.5z M9.7,5.5c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.2-0.3,0.4-0.4s0.4-0.1,0.5-0.1c0.2,0,0.3,0.1,0.5,0.3c0.1,0.2,0.2,0.3,0.3,0.6 c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.2,0.4-0.3,0.5c-0.2,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.5-0.1-0.7-0.3C9.8,6,9.7,5.7,9.7,5.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.50e42e9e6c4f7418e51ce5e21f2b8917.svg";
export { ForwardRef as ReactComponent };